// extracted by mini-css-extract-plugin
export var anchorLinkContainer = "anchor-link-module--anchorLinkContainer--c20f4";
export var copyButton = "anchor-link-module--copyButton--20b9f";